'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _DateTimeHelper = require('./DateTimeHelper');

var _DateTimeHelper2 = _interopRequireDefault(_DateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CsvExport = function () {
  function CsvExport() {
    _classCallCheck(this, CsvExport);
  }

  _createClass(CsvExport, null, [{
    key: 'convertArrayOfObjectsToCSV',


    // Funktion zum Export von CSV Dateien -->https://halistechnology.com/2015/05/28/use-javascript-to-export-your-data-as-csv/ 23.07.2018
    value: function convertArrayOfObjectsToCSV(args, key, col) {
      var result = void 0,
          ctr = void 0,
          keys = void 0,
          columnDelimiter = void 0,
          lineDelimiter = void 0,
          data = void 0,
          columnQuote = void 0;

      columnQuote = '"';
      data = args.data || null;
      if (data == null || !data.length) {
        return null;
      }

      columnDelimiter = args.columnDelimiter || ';';
      lineDelimiter = args.lineDelimiter || '\r\n';

      keys = Object.keys(data[0]);

      result = '';
      var propKeys = key;

      var propCol = col;
      var arr = [];
      for (var i = 0; i < propKeys.length; i++) {
        arr.push([propKeys[i], propCol[i]]);
      }

      for (var _i = 0; _i < propKeys.length; _i++) {

        result += arr[_i][1] + columnDelimiter;
      }
      result += lineDelimiter;

      data.forEach(function (item) {
        ctr = 0;

        var _loop = function _loop(_i2) {
          // eslint-disable-next-line
          keys.forEach(function (key) {
            var val = '';
            if (key === arr[_i2][0]) {
              var idx = '';
              //console.log(item[key].toString())
              idx = _DateTimeHelper2.default.getAllIndexes(item[key].toString(), '-');
              if (idx.length === 2) {
                try {
                  var date = new Date(item[key]);
                  val = _DateTimeHelper2.default.FormatToShortDateString(date);
                } catch (e) {
                  val = item[key];
                }
              } else {
                val = item[key];
              }
              if (ctr > 0) {
                result += columnDelimiter;
              }
              result += columnQuote + val + columnQuote;
              ctr++;
            }
          });
        };

        for (var _i2 = 0; _i2 < arr.length; _i2++) {
          _loop(_i2);
        }

        result += lineDelimiter;
      });

      return result;
    }
  }, {
    key: 'CsvDownload',
    value: function CsvDownload(csvData, tableName, keys, columns) {
      //(Datensätze als Array, Tabellenname für csv Tabelle,Spaltenkeys für Datensätze als Array,Spaltenüberschriften für csv Tabelle als Array)
      var data = void 0,
          filename = void 0,
          link = void 0;
      var csv = CsvExport.convertArrayOfObjectsToCSV({ data: csvData }, keys, columns);
      if (csv == null) {
        return;
      }
      var args = { filename: tableName + ".csv" };
      filename = args.filename || 'export.csv';

      if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(csv);
      }
      data = csv;

      link = document.createElement('a');
      link.setAttribute('href', data);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }]);

  return CsvExport;
}();

exports.default = CsvExport;